<form #form="ngForm" autocomplete="off">
    <ng-container *ngIf="jobPosting">
        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'applicant-tracker.jobTitle' | translate }}</mat-label>
                <input
                    type="text"
                    placeholder="{{ 'applicant-tracker.webDeveloper' | translate }}"
                    matInput
                    required
                    #title="ngModel"
                    name="title"
                    [(ngModel)]="jobPosting.title"
                />
                <mat-error *ngIf="title.invalid">{{ title?.errors | formErrors }}</mat-error>
            </mat-form-field>

            <app-location-type-select
                [jobPosting]="jobPosting"
                [locationTypes]="jobPosting.allLocationTypes"
                class="columns-6 small-columns-12"
            ></app-location-type-select>
        </div>

        <div class="app-grid">
            <app-address-search
                [jobPosting]="jobPosting"
                class="d-inline-block columns-6 small-columns-12"
            ></app-address-search>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'applicant-tracker.unitSuite' | translate }}</mat-label>
                <input
                    type="text"
                    placeholder="{{ 'forms.applicant-tracker.unitSuitePlaceholder' | translate }}"
                    matInput
                    #addressLine2="ngModel"
                    name="addressLine2"
                    [(ngModel)]="jobPosting.addressLine2"
                />

                <mat-error *ngIf="addressLine2.invalid">{{ addressLine2?.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'applicant-tracker.city' | translate }}</mat-label>
                <input
                    type="text"
                    placeholder="{{ 'forms.applicant-tracker.cityPlaceholder' | translate }}"
                    matInput
                    required
                    #city="ngModel"
                    name="city"
                    [(ngModel)]="jobPosting.city"
                />

                <mat-error *ngIf="city.invalid">{{ city?.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'applicant-tracker.provinceState' | translate }}</mat-label>
                <input
                    type="text"
                    placeholder="{{ 'forms.applicant-tracker.provincePlaceholder' | translate }}"
                    matInput
                    required
                    #region="ngModel"
                    name="region"
                    [(ngModel)]="jobPosting.region"
                />
                <mat-error *ngIf="region.invalid">{{ region.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'applicant-tracker.postalZipCode' | translate }}</mat-label>
                <input
                    type="text"
                    placeholder="{{ 'forms.applicant-tracker.postalZipCodePlaceholder' | translate }}"
                    matInput
                    #postalCode="ngModel"
                    name="region"
                    [(ngModel)]="jobPosting.postalCode"
                />
                <mat-error *ngIf="postalCode.invalid">{{ postalCode.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'applicant-tracker.country' | translate }}</mat-label>
                <input
                    type="text"
                    placeholder="{{ 'forms.applicant-tracker.countryPlaceholder' | translate }}"
                    matInput
                    required
                    #country="ngModel"
                    name="country"
                    [(ngModel)]="jobPosting.country"
                />
                <mat-error *ngIf="country.invalid">{{ country.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label appRemoveAriaOwns>{{ 'applicant-tracker.jobType' | translate }}</mat-label>
                <mat-select
                    name="level"
                    #level="ngModel"
                    placeholder="{{ 'applicant-tracker.jobPostingLevelPlaceholder' | translate }}"
                    [(ngModel)]="jobPosting.level"
                >
                    <mat-option value="full-time">{{ 'applicant-tracker.fullTime' | translate }}</mat-option>
                    <mat-option value="part-time">{{ 'applicant-tracker.partTime' | translate }}</mat-option>
                    <mat-option value="contract">{{ 'applicant-tracker.contract' | translate }}</mat-option>
                    <mat-option value="internship">{{ 'applicant-tracker.internship' | translate }}</mat-option>
                    <mat-option value="volunteer">{{ 'applicant-tracker.volunteer' | translate }}</mat-option>
                </mat-select>
                <mat-error *ngIf="level.invalid">{{ level.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'applicant-tracker.category' | translate }}</mat-label>
                <input
                    type="text"
                    placeholder="{{ 'applicant-tracker.sales' | translate }}"
                    matInput
                    pattern="[a-zA-Z0-9\s]+"
                    required
                    #category="ngModel"
                    name="category"
                    [(ngModel)]="jobPosting.category"
                />
                <mat-error *ngIf="category.invalid">{{ category.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <app-compensation-type-select
                [jobPosting]="jobPosting"
                class="d-inline-block columns-6 small-columns-12"
            ></app-compensation-type-select>

            <mat-form-field
                class="columns-3 small-columns-12"
                *ngIf="jobPosting.compensationType || jobPosting.payLow || jobPosting.payHigh"
            >
                <mat-label
                    >{{ 'forms.applicant-tracker.compensationRange' | translate }}
                    <div class="sr-only">{{ 'forms.fields.minimumValue' | translate }}</div></mat-label
                >
                <input
                    type="number"
                    matInput
                    min="0"
                    #payLow="ngModel"
                    name="payLow"
                    [(ngModel)]="jobPosting.payLow"
                    [placeholder]="jobPosting.payLowPlaceholder | appTranslate"
                />
                <mat-error *ngIf="payLow.invalid">{{ payLow.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field
                class="columns-3 small-columns-12 compensationPayHighV2"
                *ngIf="jobPosting.compensationType || jobPosting.payLow || jobPosting.payHigh"
            >
                <mat-label class="sr-only"
                    >{{ 'forms.applicant-tracker.compensationRange' | translate }}
                    {{ 'forms.fields.maximumValue' | translate }}</mat-label
                >
                <input
                    type="number"
                    matInput
                    #payHigh="ngModel"
                    min="0"
                    name="payHigh"
                    [(ngModel)]="jobPosting.payHigh"
                    [placeholder]="jobPosting.payHighPlaceholder | appTranslate"
                />
                <mat-error *ngIf="payHigh.invalid">{{ payHigh.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
    </ng-container>
</form>
